import {
  Auth,
  connectAuthEmulator,
  getAuth,
  indexedDBLocalPersistence,
  setPersistence,
} from 'firebase/auth';
import { isProductionEnvironment } from 'shared/utils/is-environment';

import { initAppCheck } from '../app-check';
import { initApp } from '../init-app';

let auth: Auth | undefined;

export const initAuth = async () => {
  if (!isProductionEnvironment) {
    // eslint-disable-next-line no-console -- non-prod logging
    console.log(
      `[Debug-Auth] initAuth called at ${performance.now().toFixed(0)}ms`,
    );
  }

  if (!auth) {
    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- non-prod logging
      console.log(
        '[Debug-Auth] auth is undefined. Initializing new instance...',
      );
    }
    import.meta.env.MODE !== 'development' && initAppCheck(initApp());
    auth = getAuth(initApp());

    if (
      import.meta.env.MODE === 'development' &&
      import.meta.env.VITE_FIREBASE_EMULATOR_URL
    ) {
      connectAuthEmulator(
        auth,
        `http://${import.meta.env.VITE_FIREBASE_EMULATOR_URL}:9099`,
      );
    }

    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- non-prod logging
      console.log('[Debug-Auth] Setting persistence...');
    }
    await setPersistence(auth, indexedDBLocalPersistence);

    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- non-prod logging
      console.log('[Debug-Auth] Persistence type set:', auth.name);
      // eslint-disable-next-line no-console -- non-prod logging
      console.log('[Debug-Auth] Waiting for authStateReady()...');
    }
    await auth.authStateReady();

    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- non-prod logging
      console.log(
        `[Debug-Auth] authStateReady() resolved. User UID: ${auth.currentUser?.uid}`,
      );
    }
  } else {
    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- non-prod logging
      console.log(
        `[Debug-Auth] Returning existing auth instance. User UID: ${auth.currentUser?.uid}`,
      );
    }
  }

  return auth;
};

export const clearAuth = () => {
  auth = undefined;
};
